import { Component, createSignal, onMount } from 'solid-js'
import { parse } from 'valibot'
import { backendAxios } from '../axios'
import AlertBag from '../components/AlertBag'
import EditAvatar from '../components/EditAvatar'
import Loader from '../components/Loader'
import { createAlertBagStore, setAlertBagError, setAlertBagSuccess } from '../rx/store/AlertBag'
import { PatchMyProfileBodySchema } from '../backend_schemas'
import { getAuthProfile, setAuthProfile } from '../rx/shared/profile/createAuthProfileSignal'
import { isOfflineOnly } from '../lib/core/isOfflineOnly'

const ProfilePage: Component = () => {
  const [isLoading, setIsLoading] = createSignal<boolean>(false)
  const alertBag = createAlertBagStore()

  // Use local profile from localStorage
  const profile = getAuthProfile()

  const [dname, setDname] = createSignal<string>(profile?.dname || '')
  const [bio, setBio] = createSignal<string>(profile?.bio || '')

  // Update local state when profile changes
  onMount(() => {
    // In offline mode, we just use the local profile
    // No need to fetch from backend
    if (!isOfflineOnly) {
      // Online mode: could fetch latest profile from backend if needed
      // For now, just use local profile
    }
  })

  const handleUpdate = async (e: Event) => {
    e.preventDefault()
    setIsLoading(true)
    setAlertBagError(alertBag, null)
    try {
      const payload = {
        dname: dname(),
        bio: bio(),
      }
      const validated = parse(PatchMyProfileBodySchema, payload)
      
      if (!isOfflineOnly) {
        await backendAxios.patch('/profile/me', validated)
      }
      
      // Update local profile
      setAuthProfile({
        ...profile,
        ...payload,
      } as Parameters<typeof setAuthProfile>[0])
      
      setAlertBagSuccess(alertBag, 'Profile updated successfully')
    } catch (err) {
      setAlertBagError(alertBag, err as Error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleAvatarUpload = () => {
    // Avatar upload handled by EditAvatar component
    // This callback can be used for additional actions if needed
  }

  return (
    <div class="container mt-5">
      <h2>Profile</h2>
      <AlertBag store={alertBag} />
      <div class="row">
        <div class="col-md-4 text-center mb-4">
          <EditAvatar size={150} onUpload={handleAvatarUpload} />
        </div>
        <div class="col-md-8">
          <form onSubmit={handleUpdate}>
            <div class="mb-3">
              <label class="form-label">Display Name</label>
              <input
                type="text"
                class="form-control"
                value={dname()}
                onInput={(e) => setDname(e.currentTarget.value)}
                disabled={isLoading()}
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Bio</label>
              <textarea
                class="form-control"
                value={bio()}
                onInput={(e) => setBio(e.currentTarget.value)}
                disabled={isLoading()}
              />
            </div>
            <button type="submit" class="btn btn-primary" disabled={isLoading()}>
              {isLoading() ? <Loader /> : 'Update Profile'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ProfilePage
